// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 3090 ? "AssignHomework" : chunkId) + "." + {"3090":"07973d5e","6791":"d4193b6e"}[chunkId] + ".chunk.css";
};